module.exports = __webpack_public_path__ + "images/emoji/clock7.10898c603e7beb177969.png";